import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-132" data-mp="3kqw36hd9ewej">
      <div className="mx-auto max-w-5xl" data-id="element-133" data-mp="3fycrjpy4ubcd">
        <h2 className="text-center font-display text-3xl uppercase text-cream sm:text-5xl" data-id="element-134" data-mp="3fxb4so7r80et">
          Ils enseignent <span className="text-gold" data-id="element-135" data-mp="36yzhav26piql">autrement</span>
        </h2>
        <div className="mt-8 grid gap-4 sm:mt-12 sm:gap-6 md:grid-cols-3" data-id="element-136" data-mp="370ajiqfzeifl">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-line bg-ink p-6" data-id="element-137" data-mp="321zaghxigbyf">
              <div className="flex gap-1 text-gold" aria-label="5 étoiles sur 5" data-id="element-138" data-mp="2x2mnzyajx6wd">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-139" data-mp="v9oq3o1x3o4k" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 font-serif text-base italic leading-relaxed sm:text-lg text-cream" data-id="element-140" data-mp="qbn5uzsr9iri">« {t.quote} »</blockquote>
              <figcaption className="mt-auto pt-6" data-id="element-141" data-mp="h8az7g8j0vsa">
                <p className="font-bold text-cream" data-id="element-142" data-mp="m62mty251vqo">{t.name}</p>
                <p className="text-sm text-mute" data-id="element-143" data-mp="780j9nv3xa9f">{t.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}